<template>
  <div class="select_dialog_embed">
    <div class="goods_list_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div v-if="showType === 'goodDetail'" class="select_dialog_embed_box_content">
          <!--货品详情-->
          <div class="select_dialog_embed_box_handle">
            <!--货品详情上部分——包含图片-->
            <div class="good_detail_top">
              <div class="good_detail_top_left clear">
                <table>
                  <tr>
                    <td class="text_right fwb">货号：</td>
                    <td colspan="3" class="text_left">{{goodDetail.GoodsId}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">款号：</td>
                    <td colspan="3" class="text_left">{{goodDetail.GoodsName}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">零售价：</td>
                    <td class="text_left">{{goodDetail.MarketPrice}}</td>
                    <td class="text_right fwb">性别：</td>
                    <td class="text_left">{{goodDetail.Gender | gender}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">码段：</td>
                    <td class="text_left">{{goodDetail.SGName}}</td>
                    <td class="text_right fwb">分类：</td>
                    <td class="text_left">{{goodDetail.ClassName}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">创建时间：</td>
                    <td class="text_left">{{goodDetail.CreateTime | time}}</td>
                    <td class="text_right fwb">上市季节：</td>
                    <td class="text_left">{{goodDetail.MarketSeasoin}}</td>
                  </tr>
                </table>
              </div>
              <div class="good_detail_top_right clear">
                <img :src="goodDetail.MainImgUrl" height="200" width="200"/>
                <!--<a v-if="isShowZip" title="下载货品图片压缩包" @click="downImgZip()">下载货品图片压缩包</a>-->
              </div>
            </div>
            <!--货品详情下部分——表格-->
            <div class="good_detail_bottom">
              <!--表格固定头部-->
              <table class="table">
                <colgroup>
                  <col style=" width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th>颜色</th>
                  <th>尺码（[美国码][欧洲码]）</th>
                  <th>商家编码</th>
                  <th>条码</th>
                  <th>重量（g）</th>
                </tr>
                </thead>
              </table>
              <!--表格滚动内容-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody v-if="goodDetail.Skus">
                <tr v-for="(item, index) in goodDetail.Skus" :key="index">
                  <td>{{item.ColorAlias}}</td>
                  <td>{{item.Size}}([{{item.AmericanSize}}][{{item.EuropeSize}}])</td>
                  <td>{{item.BusinessCode}}</td>
                  <td>{{item.BarCode}}</td>
                  <td>{{item.GoodsSkuWeight}}</td>
                </tr>
                </tbody>
                <tbody v-if="!goodDetail.Skus">
                <tr>
                  <td colspan="5">暂时没有相关内容</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_cancel" @click="submitBtn()">关闭</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  export default {
    name: 'goods-list-embed-msg',
    /**
     *  title：  头部名
     *  showType: goodDetail=货品详情信息
     *  goodMsg: 货品信息
     * */
    props: ['title', 'showType', 'goodMsg'],
    components: {MsgDialog},
    data() {
      return {
        goodDetail: '', // 公告详情
        isShowZip: false, // 是否显示下载压缩包按钮
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 查看货品详情
      getGoodsInfoById() {
        this.$axios.post(this.Global.getGoodsInfoById(this.goodMsg.GoodsId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.goodDetail = res.data.resData;
            if (this.goodDetail.MainImgUrl === '') {
              this.goodDetail.MainImgUrl = null;
            }
            this.isShowZip = this.goodDetail.ZipImgUrl !== '';
           /* if (this.goodDetail.ZipImgUrl !== '') {
              this.isShowZip = true;
            } else {
              this.isShowZip = false;
            } */
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 下载商品图片压缩包
      downImgZip() {
        this.$axios.get(this.Global.downImgZip(this.goodMsg.GoodsId)).then((res) => {
          // window.open(res.data, '_blank');
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 提交按钮
      submitBtn() {
        this.cancelBtn(this.showType);

        // 计时器
        if (this.isMsg) {
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              self.isMsg = false;
              clearInterval(self.timer);
            }
          }, 1000);
        }
      },

      // 取消按钮
      cancelBtn(showType) {
        this.$emit('cancelbtn', {isShow: false, showType: showType});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getGoodsInfoById();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .select_dialog_embed {
    .goods_list_embed_msg {
      width: 90%;
      min-width: 580px;
      max-height: 100%;

      .select_dialog_embed_box {
        width: 100%;

        .select_dialog_embed_box_handle {
          width: 100%;
          margin-top: 10px;

          .good_detail_top {
            width: 100%;
            height: 200px;

            .good_detail_top_left, .good_detail_top_right {
              display: inline-block;
              float: left;
              height: 100%;
            }

            .good_detail_top_left {
              /*background-color: #13ce66;*/
              width: 55%;

              table {
                width: 73%;
                margin-left: 30px;
                border: none;

                tr {
                  border: none;
                }

                th, td {
                  border: none;
                  padding: 10px 0;
                }
              }
            }

            .good_detail_top_right {
              width: 45%;

              a {
                color: $calink;
                margin-left: 30px;
                position: relative;
                bottom: 15px;

                &:hover {
                  cursor: pointer;
                }
              }
            }
          }

          .good_detail_bottom {
            width: 98%;
            margin: 10px auto;
            text-align: center;

            table {
              &:nth-child(2) {
                border-bottom: 1px solid #eee;
              }

              thead, tbody tr {
                display: table;
                width: 100%;
                table-layout: fixed;
              }

              tbody {
                display: block;
                width: 100%;
                height: 290px;
                overflow-y: auto;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/goods-list-embed-msg.vue